import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function PrivateRoute({
  component: Component,
  disableRoles,
  denyRoles,
  allowRoles,
  ...rest
}) {
  const { currentUser } = useAuth();
  // Keep old callers compatible; use allowRoles for routes that need strict access.
  void disableRoles;

  return (
    <Route
      {...rest}
      // render={(props) => {
      //   return currentUser ? (
      //     disableRoles ? (
      //       !disableRoles.includes(currentRole) ? (
      //         <Component {...props} />
      //       ) : (
      //         <></>
      //       )
      //     ) : (
      //       <Component {...props} />
      //     )
      //   ) : (
      //     <Redirect to={"/page-login"} />
      //     // )
      //   );
      // }}
      render={(props) => {
        if (!currentUser) {
          return <Redirect to={"/page-login"} />;
        }

        const currentRoles = Array.isArray(currentUser.roles)
          ? currentUser.roles
          : [];
        if (
          allowRoles &&
          !allowRoles.some((role) => currentRoles.includes(role))
        ) {
          return <Redirect to={"/"} />;
        }

        if (
          denyRoles &&
          denyRoles.some((role) => currentRoles.includes(role))
        ) {
          return <Redirect to={"/"} />;
        }

        return <Component {...props} />;
      }}
    ></Route>
  );
}
